import React, { useEffect } from 'react';
import { formatDate, formatIndianCurrency, saveLogEvent } from '../../utils/Utils';

const StatementOfAccount = ({ Summary, labels }) => {

  useEffect(()=>{
     saveLogEvent({
                logLevel: "info",
                statusCode: 200,
                status: "success",
                message: {
                   Page:"Statement of Account Page",
                   trigger: "On Load of Soa Page",
                },
                payload:{
                  Page:"Statement of Account Page",
                   trigger: "On Load of Soa Page",
                }
            });
  },[])
  return (
    <div className="sticky top-[30vh] bg-white  z-10 mx-4">
      <div className="bg-yellow-500 text-center py-2 font-semibold text-lg  px-4">
        {labels.statementOfAccount}
      </div>
      <div className="p-4 space-y-2 border-b-2 border-r-2 border-l-2">
        <div className="flex justify-between">
          <span>{labels.loanAmount}</span>
          <span>{formatIndianCurrency(Summary.LoanSchemePrincipal)}</span>
        </div>
        <div className="flex justify-between">
          <span>{labels.disbursementDate}</span>
          <span>{formatDate(Summary.LoanDateofDisbursement)}</span>
        </div>
        <div className="flex justify-between">
          <span>{labels.balanceOutstanding}</span>
          <span>{formatIndianCurrency(Summary.BalanceOutstanding)}</span>
        </div>
        <div className="flex justify-between">
          <span>{labels.firstCollectionDate}</span>
          <span>{formatDate(Summary.FirstCollectionDate)}</span>
        </div>
      </div>
    </div>
  );
};

export default StatementOfAccount;
